import { Link } from 'react-router-dom';

export default function WhatIs() {
  return (
    <section id="co-to-jest" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              Podstawy
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5 leading-tight">
              USFansSpreadsheet: Co to jest i jak działa w 2026 roku?
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-4">
              <strong className="text-foreground-950">USFansSpreadsheet</strong> to zaawansowane narzędzie do zarządzania arkuszami kalkulacyjnymi, 
              zaprojektowane z myślą o użytkownikach poszukujących wydajnego i intuicyjnego rozwiązania do analizy danych. 
              Platforma łączy w sobie elastyczność tradycyjnych arkuszy kalkulacyjnych z nowoczesnymi funkcjami automatyzacji 
              i współpracy zespołowej.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              Niezależnie od tego, czy jesteś początkującym użytkownikiem, czy doświadczonym analitykiem danych, 
              <strong className="text-foreground-950"> USFansSpreadsheet</strong> oferuje narzędzia, które pomogą Ci 
              efektywniej zarządzać projektami, śledzić postępy i podejmować lepsze decyzje biznesowe.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-6">
              W naszym <strong>kompletnym przewodniku USFansSpreadsheet</strong> znajdziesz wszystko – od podstawowej konfiguracji 
              po zaawansowane techniki, które pomogą Ci w pełni wykorzystać potencjał tego narzędzia.
            </p>
            <Link
              to="/artykul/kompletny-przewodnik-usfansspreadsheet-2026"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Czytaj pełny przewodnik
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20desk%20setup%20with%20cream%20laptop%20on%20light%20oak%20wood%20desk%2C%20terracotta%20ceramic%20coffee%20mug%2C%20dried%20flowers%20in%20beige%20vase%2C%20warm%20afternoon%20sunlight%20through%20sheer%20curtains%2C%20Scandinavian%20interior%20design%2C%20soft%20natural%20textures%2C%20peaceful%20atmosphere&width=800&height=600&seq=what-is-new-img-p2&orientation=landscape"
                alt="USFansSpreadsheet - nowoczesny interfejs arkusza kalkulacyjnego na laptopie"
                title="USFansSpreadsheet - interfejs arkusza kalkulacyjnego"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}